import {
  dateFormatter,
  getShipmentInfoFromStops,
  stopRenderer,
  convertCMtoMeters,
  getShipperOrderPallets,
  warningRenderer,
} from '../utils';

const FR_SO_template = (SO) => {
  const { data, costQuote } = SO;
  const { net_full_cost } = costQuote;
  const { start_time_from, end_time_to, stops, extras, shipper, id, total_weight } = data;
  const { company_name } = shipper;
  const country = 'FR';

  const when = dateFormatter(start_time_from, end_time_to, country);
  const stopsToRender = stopRenderer(stops, country).join('');
  const warning = warningRenderer(extras, country);
  const stopsInfo = getShipmentInfoFromStops(stops, country);
  const payload = getShipperOrderPallets(data, country);
  const maxHeight = convertCMtoMeters(data.item_height);

  return `
    NEW JOB:

    WHEN: ${when}

    COMPANY: ${company_name}

    We pay you: ${net_full_cost}€ + VAT
    Total weight: ${total_weight} kg
    Payload: ${payload}
    Max. pallet height: ${maxHeight}

    ${stopsInfo.PICKUP} Pickup(s), ${stopsInfo.DROPOFF} Dropoff(s)
    ${stopsToRender}
    ${warning}

    To indicate that you would like to *accept this job, please reply with the following information:
    - Reference number(${id})
    - The registration number of the vehicle that will be used for the job and the name of the driver
    `;
};

export default FR_SO_template;
